<script>
import AppStory from './AppStory.vue'
import Stories from '../data/stories'

export default {
	name: 'ArticleMore',
	props: {
		ids: {
			type: Array,
			default: [1, 2, 3]
		}
	},
	components: {
		AppStory,
	},
	created() {
		this.stories = []
		for (let i = 0; i < this.ids.length; i++) {
			this.stories[i] = Stories[this.ids[i] - 1]
		}
	}
}
</script>



<template>
<div class="article-more">
	<app-story
		:image="story.image"
		:size="story.size"
		:type="story.type"
		:link="story.link"
		:key="index"
		v-for="(story, index) in stories"
	>
		<h2 slot="title" v-html="story.title"></h2>
		<p slot="text" v-html="story.text"></p>
	</app-story>
</div>
</template>

<style lang="less" scoped>
@import "../styles/colors.less";
@import "../styles/fonts.less";

.article-more {
	width: 100vw;
	height: auto;
	position: relative;
}

.story h2 {
	width: 90%;
	margin: 0 auto;
	font-size: 23px;
}

.story p {
	width: 90%;
	margin: 0 auto;
	padding-bottom: 5vh;
	font-size: 23px;
	font-family: @fontLava;
	font-weight: 600;
	transition: all 200ms ease;
}


@media only screen and (max-width: 1240px) {


.story {
	h2 {
		font-size: 15px;
		padding-bottom: 1vh;
	}
	p {
		font-size: 15px;
		padding-bottom: 2vh;
	}
}


}


</style>



// WEBPACK FOOTER //
// ArticleMore.vue?51e3cb1c